import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/progress-bar-list';
import AggregateNumber from "../../aggregate/aggregate-number";
import AggregateProgressComponent from "./components/aggregate-progress";
import normalizeNumber from "../../import/normalize/normalize-number";
import FieldNumberViewInImport from "../../import/view-in-preview/number-view-in-import";

export default class ProgressBarField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.PROGRESS_BAR;
        this.valueType = gd.const.fields.valueType.FLOAT;
        this.formulaCompatible = true;
    }

    get sortHintMessage() {
        return 'Sort by progress';
    }

    getAggregateValue(item) {
        return item.progress || 0
    }

    getCsvValue(item) {
        return item.progress;
    }

    getValue(item) {return item.progress}

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.AVERAGE}

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.item.progress || 0],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    get AggregateComponent() {return AggregateProgressComponent.bind(null, this.getAggregateOptions());}


    // IMPORT

    normalizeCSVValue(value) {
        value = normalizeNumber(value);

        if (value>=0 && value<=100) {
            return value;
        }
        return null;
    }

    getComponentViewInImport() {
        return FieldNumberViewInImport;
    }

}